"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.VerticallyAlignWrapper = exports.Legend = exports.Label = exports.Info = exports.GroupWrapper = exports.Error = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Label = _interopRequireDefault(require("../Typography/Label"));
var _helpers = require("../helpers");
var _mixins = require("../mixins");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var Wrapper = _styledComponents["default"].div.attrs(function (props) {
  return {
    mB: props.mB,
    w: props.w || props.width
  };
}).withConfig({
  displayName: "FieldParts__Wrapper",
  componentId: "sc-jnm2af-0"
})(["display:flex;flex-direction:", ";flex:", ";position:relative;width:100%;gap:", ";", ";", ";", ";", ";"], function (props) {
  return props.direction || "column";
}, function (props) {
  return props.flex || "1 1 auto";
}, function (props) {
  return props.theme.fields.gap;
}, function (props) {
  return props.gap && (0, _styledComponents.css)(["gap:", ";"], (0, _helpers.getSpace)(props, "gap"));
}, function (props) {
  return props.gapV && (0, _styledComponents.css)(["row-gap:", ";"], (0, _helpers.getSpace)(props, "gapV", "xs"));
}, function (props) {
  return props.mB && (0, _styledComponents.css)(["margin-bottom:", ";"], props.mB === true ? props.theme.fields.mB : (0, _helpers.getSpace)(props, "mB", "base"));
}, function (props) {
  return props.w && (0, _styledComponents.css)(["width:", ";flex-grow:0;flex-shrink:0;"], props.w);
});
exports.Wrapper = Wrapper;
Wrapper.displayName = "FieldParts.Wrapper";
var GroupWrapper = (0, _styledComponents["default"])(Wrapper).attrs(function (props) {
  return {
    as: "fieldset"
  };
}).withConfig({
  displayName: "FieldParts__GroupWrapper",
  componentId: "sc-jnm2af-1"
})(["padding:0;border:none;margin:0;", ";display:block;> * + *{margin-top:", ";}"], function (props) {
  return props.mB && (0, _styledComponents.css)(["margin-bottom:", ";"], props.mB === true ? props.theme.fields.mB : (0, _helpers.getSpace)(props, "mB", "base"));
}, function (props) {
  return props.theme.fields.gap;
});
exports.GroupWrapper = GroupWrapper;
GroupWrapper.displayName = "FieldParts.GroupWrapper";
var labelMixin = (0, _styledComponents.css)(["flex-shrink:0;display:flex;align-items:center;", ";", ";"], function (props) {
  return props.w && (0, _styledComponents.css)(["width:", ";"], props.w);
}, function (props) {
  return props.hasError && (0, _styledComponents.css)(["color:", ";"], props.theme.colors.error);
});
var Label = (0, _styledComponents["default"])(_Label["default"]).withConfig({
  displayName: "FieldParts__Label",
  componentId: "sc-jnm2af-2"
})(["", " ", ";", " ", ";"], labelMixin, function (props) {
  return !props.above && (0, _styledComponents.css)(["height:", ";"], props.theme.fields.height);
}, function (props) {
  return props.isHighlighted && (0, _styledComponents.css)(["color:", ";"], props.theme.colors.success_2);
}, function (props) {
  return props.h && (0, _styledComponents.css)(["height:", ";"], props.h === "fieldsHeight" ? props.theme.fields.height : props.h);
});
exports.Label = Label;
Label.displayName = "FieldParts.Label";
var Legend = (0, _styledComponents["default"])(_Label["default"]).attrs(function (props) {
  return {
    as: "legend"
  };
}).withConfig({
  displayName: "FieldParts__Legend",
  componentId: "sc-jnm2af-3"
})(["", " ", ";"], labelMixin, function (props) {
  return props.variant && props.variant === "invisible" && (0, _styledComponents.css)(["", ";"], _mixins.hiddenButReaderAccessibleMixin);
});
exports.Legend = Legend;
Legend.displayName = "FieldParts.Legend";
var Info = (0, _styledComponents["default"])(_Label["default"]).attrs(function (props) {
  return _objectSpread({
    as: "div",
    color: props.color || "textSecondary"
  }, (0, _helpers.getDataHookProp)(props.automationHook));
}).withConfig({
  displayName: "FieldParts__Info",
  componentId: "sc-jnm2af-4"
})(["display:block;width:100%;"]);
exports.Info = Info;
Info.displayName = "FieldParts.Info";
var Error = (0, _styledComponents["default"])(_Label["default"]).attrs({
  as: "div",
  hasError: true
}).withConfig({
  displayName: "FieldParts__Error",
  componentId: "sc-jnm2af-5"
})(["", " display:block;height:auto;"], labelMixin);

/* Component used to add spacing over a field/button when we want to align it to other fields that have labels
 * You would want to use this instead of aligning the item relative to container bottom because that would miss-align items when there are errors
 */
exports.Error = Error;
var VerticallyAlignWrapper = _styledComponents["default"].div.withConfig({
  displayName: "FieldParts__VerticallyAlignWrapper",
  componentId: "sc-jnm2af-6"
})(["padding-top:calc( ", " + ", " );"], function (props) {
  return props.theme.lineHeights.labelsPx;
}, function (props) {
  return props.theme.fields.gap;
});
exports.VerticallyAlignWrapper = VerticallyAlignWrapper;
VerticallyAlignWrapper.displayName = "FieldParts.VerticallyAlignWrapper";